import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Bg from "../../assets/images/avatars/dash-bg-4.png";
import Logo from "../../assets/images/logo_stroke_gold.png";
import cnt from "../../services/definedConstant";
import { BOM } from "../../services/definedMethod";
import { apiConfig } from "../../pages/security/security.config";
import appConfig from "../../config/appConfig";
import { parsePermissions } from "../../services/authSession";

const { Title, Text } = Typography;

const TwoFactorAuth = ({ userData }) => {
  const { session } = userData;
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [tokenSent, setTokenSent] = useState(false);
  const [deliveryMethod, setDeliveryMethod] = useState("email");
  const [rememberComputer, setRememberComputer] = useState(false);
  const [twoFactorData, setTwoFactorData] = useState(null);
  const [tokenExpired, setTokenExpired] = useState(true);
  const [timeRemaining, setTimeRemaining] = useState(280); // 5 minutes in seconds
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  useEffect(() => {
    console.log(state);
    if (!userData) {
      navigate("/login");
      return;
    }
    getTwoFactorData();
  }, []);

  // Countdown timer effect
  useEffect(() => {
    if (tokenSent && timeRemaining > 0) {
      const timer = setInterval(() => {
        setTimeRemaining((prev) => {
          if (prev <= 1) {
            setTokenExpired(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [tokenSent, timeRemaining]);

  const getTwoFactorData = () => {
    const url = `${apiConfig.TwoFactor}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        console.log("2FA data fetch error:", err);
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors[0]?.defaultUserMessage ||
            err?.defaultUserMessage ||
            "Failed to load two-factor authentication data",
        );
      } else {
        setTwoFactorData(res[0]);
      }
    });
  };

  const handleRequestToken = () => {
    const params = {
      deliveryMethod: deliveryMethod,
      extendedToken: rememberComputer.toString(),
    };
    const url = `${apiConfig.TwoFactor}`;

    const body = {
      method: "POST",
      params,
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);
      if (err) {
        console.log("2FA token request error:", err);
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors[0]?.defaultUserMessage ||
            err?.defaultUserMessage ||
            "Failed to send authentication token",
        );
      } else {
        setTokenSent(true);
        setTimeRemaining(280); // Reset to 5 minutes
        setTokenExpired(false); // Reset expired state
        BOM.AlertMsg(cnt.SUCCESS, `Authentication token sent successfully via ${deliveryMethod}`);
      }
    });
  };

  // function getDecryptedValueFromOtp(input, key) {
  //   if (typeof input !== "string" || typeof key !== "string") return null;

  //   return input
  //     .split(":")
  //     .map((part) => part.split("="))
  //     .reduce((acc, [k, v]) => {
  //       if (String(k).toLowerCase() === String(key).toLowerCase()) acc = v || null;
  //       return acc;
  //     }, null);
  // }

  const handleVerifyToken = (values) => {
    const url = `${apiConfig.TwoFactor}/validate`;

    const verificationCode = BOM.GenerateRandomString(6);
    const encryptedToken = btoa(values.authToken);
    const encryptedTfvc = verificationCode;

    const body = {
      method: "POST",
      session,
      token: encryptedToken,
      tfvc: encryptedTfvc,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);
      if (err) {
        console.log("2FA token verification error:", err);
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors[0]?.defaultUserMessage ||
            err?.defaultUserMessage ||
            err?.message ||
            "Invalid authentication token",
        );
      } else {
        console.log(res, "res");
        // const decrypted = decryptPayload(res?.tfvc);
        // const decryptedVerificationCode = getDecryptedValueFromOtp(decrypted, "verificationCode");
        // const username = getDecryptedValueFromOtp(decrypted, "username");
        // const token = getDecryptedValueFromOtp(decrypted, "token");

        // if (
        //   String(decryptedVerificationCode) !== String(verificationCode) ||
        //   String(username) !== String(state?.username) ||
        //   String(token) !== String(values.authToken)
        // ) {
        //   BOM.AlertMsg(cnt.DANGER, "Invalid token");
        //   return;
        // }

        // const tfaToken = res?.token || res?.tfaToken || res?.authToken;

        // if (tfaToken) {
        //   appConfig.apiSettings.headers["Fineract-Platform-TFA-Token"] = tfaToken;
        //   Cookies.set("tfaToken", tfaToken, {
        //     path: "/",
        //     sameSite: "strict",
        //     expires: 365,
        //     secure: window.location.protocol === "https:",
        //   });
        // } else {
        //   console.warn("No TFA token found in response");
        // }

        // Prepare updated user data with TFA token
        const updatedUserData = {
          ...userData,
          // isTwoFactorAuthenticationRequired: false,
          twoFactorAuthenticated: true,
          // tfaToken: tfaToken,
        };

        BOM.AlertMsg(cnt.SUCCESS, "Authentication successful!");
        if (state?.shouldRenewPassword) {
          console.log(state?.shouldRenewPassword, "2FA complete, redirecting to password reset");
          setTimeout(() => {
            navigate("/reset-password", { state: updatedUserData });
          }, 1000);
        } else {
          getDetailById(updatedUserData);
          // Regular 2FA flow - go to dashboard
          console.log(state?.shouldRenewPassword, "2FA complete, redirecting to dashboard");
          // setTimeout(() => {
          //   navigate("/dashboard");
          // }, 1000);
        }
      }
    });
  };
  const getDetailById = (updatedUserData) => {
    setIsLoading(true);
    const url = `${apiConfig.Users}/${state?.userId}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage || err?.message);
        navigate("/login");
      } else {
        const permissions = parsePermissions(res?.permissions) || [];
        const userData = {
          ...updatedUserData,
          ...res,
          roles: res?.selectedRoles ?? [],
          permissions,
        };
        navigate("/dashboard");
        dispatch({
          type: cnt.SIGN_IN,
          payload: userData,
        });
      }
    });
  };
  const handleDeliveryMethodChange = (e) => {
    setDeliveryMethod(e.target.value);
  };

  const handleRememberComputerChange = (e) => {
    setRememberComputer(e.target.checked);
  };

  if (!userData) {
    return null;
  }

  const userEmail = twoFactorData?.target || "@mail.com";

  return (
    <>
      <img className="auth-bg" src={Bg} />
      <div className="login-container">
        <Card className="login-card">
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            {/* Header */}
            <div style={{ textAlign: "center" }}>
              <Title level={2} style={{ color: "#15CCAE", marginBottom: "8px" }}>
                Two-Factor Authentication
              </Title>
              <Text type="secondary">
                Please select how you would like to receive an authentication token.
              </Text>
            </div>

            {!tokenSent ? (
              <>
                {/* Token Request Section */}
                <div style={{ marginBottom: "20px" }}>
                  <Space direction="vertical" style={{ width: "100%" }}>
                    <Radio.Group
                      value={deliveryMethod}
                      onChange={handleDeliveryMethodChange}
                      style={{ width: "100%" }}
                    >
                      <Radio
                        value="email"
                        style={{
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px 0",
                        }}
                        className="of-twoFactor-radio"
                      >
                        Send via Email to{" "}
                        <strong style={{ color: "#15CCAE", marginLeft: "4px" }}>{userEmail}</strong>
                      </Radio>
                    </Radio.Group>

                    {/* <Checkbox
                      checked={rememberComputer}
                      onChange={handleRememberComputerChange}
                      style={{ marginTop: "15px" }}
                    >
                      Remember this computer
                    </Checkbox> */}
                  </Space>
                </div>

                <Button
                  type="primary"
                  onClick={handleRequestToken}
                  loading={isLoading}
                  className="of-authBtnColor"
                  size="large"
                  style={{
                    height: "48px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  {isLoading ? "SENDING..." : "REQUEST TOKEN"}
                </Button>
              </>
            ) : (
              <>
                {/* Token Verification Section */}
                {tokenExpired ? (
                  <Alert
                    message="Token has expired"
                    description={`The authentication token sent to your ${deliveryMethod} has expired. Please request a new one.`}
                    type="error"
                    showIcon
                    style={{ borderRadius: "8px" }}
                  />
                ) : (
                  <Alert
                    message="Token Sent Successfully"
                    description={`An authentication token has been sent to your ${deliveryMethod}. Please enter it below to continue.`}
                    type="success"
                    showIcon
                    style={{ borderRadius: "8px" }}
                  />
                )}

                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleVerifyToken}
                  autoComplete="off"
                  size="large"
                >
                  <Form.Item
                    label="Authentication Token"
                    name="authToken"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the authentication token!",
                      },
                      {
                        len: 5,
                        message: "Token must be 5 digits",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter 5-digit token"
                      maxLength={5}
                      style={{
                        borderRadius: "10px",
                        textAlign: "center",
                        fontSize: "18px",
                        letterSpacing: "3px",
                        padding: "10px",
                      }}
                    />
                  </Form.Item>

                  {/* Token Timeout Countdown */}
                  <div
                    style={{
                      textAlign: "center",
                      marginBottom: "10px",
                      padding: "12px",
                      backgroundColor: timeRemaining <= 60 ? "#fff2f0" : "#f6ffed",
                      borderRadius: "8px",
                      border: `1px solid ${timeRemaining <= 60 ? "#ffccc7" : "#b7eb8f"}`,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: "14px",
                        color: timeRemaining <= 60 ? "#cf1322" : "#52c41a",
                        fontWeight: "600",
                      }}
                    >
                      Token expires in:{" "}
                      <span style={{ fontSize: "18px", fontFamily: "monospace" }}>
                        {Math.floor(timeRemaining / 60)}:
                        {String(timeRemaining % 60).padStart(2, "0")}
                      </span>
                    </Text>
                  </div>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={isLoading}
                      className="of-authBtnColor"
                      size="large"
                      style={{
                        borderRadius: "8px",
                        fontSize: "16px",
                        fontWeight: "600",
                        marginTop: "10px",
                      }}
                      disabled={tokenExpired}
                    >
                      {isLoading ? "VERIFYING..." : "VERIFY TOKEN"}
                    </Button>
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="link"
                      onClick={() => {
                        setTokenSent(false);
                        setTimeRemaining(280); // Reset to 5 minutes
                        setTokenExpired(true); // Reset expired state
                        form.resetFields();
                      }}
                      style={{
                        width: "100%",
                        textAlign: "center",
                        color: "#666",
                        marginTop: "10px",
                      }}
                    >
                      Request new token
                    </Button>
                  </Form.Item>
                </Form>
              </>
            )}

            {/* Footer */}
            <Row>
              <Col span={24}>
                <Footer />
              </Col>
            </Row>
          </Space>
        </Card>
      </div>
    </>
  );
};

const Footer = () => {
  return (
    <div style={{ marginLeft: 100, marginTop: 5 }}>
      {"Powered by "}
      <img src={Logo} alt="" style={{ margin: 0, padding: 0, width: 20 }} />
      <a
        style={{ textDecoration: "none", color: "#000" }}
        href="https://openfactorgroup.com/"
        target="_blank"
      >
        <strong>penfactor</strong>
      </a>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TwoFactorAuth);
